import { FSharpRef, toString, Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { record_type, class_type, union_type, string_type, bool_type, lambda_type, unit_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { FSharpResult$2 } from "../../fable_modules/fable-library.3.7.20/Choice.js";
import { FunctionComponent_Of_Z5A158BBF } from "../../fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import { useSelector } from "../../Redux/Store.js";
import { SaveStatus, getTranslationFrom } from "../../Global.js";
import * as react from "react";
import { renderAsModalThenSaveState } from "../../Components/Modals/SaveState/SaveState.js";
import { ModalSize } from "../../Components/Modal/Modal.js";
import { SelectOption, ValueProp, SelectOption_get_getDefault, selectOption } from "../../Components/FormFields/FormFields.js";
import { singleton as singleton_1, ofArray } from "../../fable_modules/fable-library.3.7.20/List.js";
import { tryParse } from "../../fable_modules/fable-library.3.7.20/Boolean.js";
import { Browser_Types_Event__Event_get_Value } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Extensions.fs.js";
import { ButtonProps, defaultProps } from "../../Components/Button/Button.js";
import { startImmediate } from "../../fable_modules/fable-library.3.7.20/Async.js";
import { singleton } from "../../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { uncurry } from "../../fable_modules/fable-library.3.7.20/Util.js";
import "../../../src/Containers/PauseTerminationProcess/View.scss";


export class PauseTerminationProcessModalProps extends Record {
    constructor(CloseModalFn, PauseTerminationProcessFn, Header) {
        super();
        this.CloseModalFn = CloseModalFn;
        this.PauseTerminationProcessFn = PauseTerminationProcessFn;
        this.Header = Header;
    }
}

export function PauseTerminationProcessModalProps$reflection() {
    return record_type("Containers.PauseTerminationProcess.View.PauseTerminationProcessModalProps", [], PauseTerminationProcessModalProps, () => [["CloseModalFn", lambda_type(unit_type, unit_type)], ["PauseTerminationProcessFn", lambda_type(bool_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, string_type], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", string_type]]])]))], ["Header", string_type]]);
}

export const renderPauseTerminationProcessModal = FunctionComponent_Of_Z5A158BBF((props) => {
    let children_2, children, inputRecord, LabelText, OptionValues;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const saveState = react.useState(new SaveStatus(0));
    const pauseState = react.useState(true);
    return renderAsModalThenSaveState(true, new ModalSize(1), props.Header, (children_2 = [(children = [selectOption((inputRecord = SelectOption_get_getDefault(), (LabelText = getTranslation("CustomerContract.Invoicee.TerminationState.Paus"), (OptionValues = ofArray([["true", getTranslation("Common.Yes")], ["false", getTranslation("Common.No")]]), new SelectOption(new ValueProp(0, toString(pauseState[0]), (e) => {
        let matchValue;
        let outArg = false;
        matchValue = [tryParse(Browser_Types_Event__Event_get_Value(e), new FSharpRef(() => outArg, (v) => {
            outArg = v;
        })), outArg];
        if (matchValue[0]) {
            pauseState[1](matchValue[1]);
        }
    }), "pause-termination-process-action", OptionValues, inputRecord.Classes, LabelText, inputRecord.Disabled, inputRecord.HTMLProps)))))], react.createElement("div", {
        className: "pause-termination-process__body",
    }, ...children))], react.createElement("div", {
        className: "pause-termination-process",
        id: "pause-termination-process-modal",
    }, ...children_2)), new ButtonProps(getTranslation("Common.Cancel"), defaultProps.Content, (_arg_1) => {
        props.CloseModalFn();
    }, defaultProps.Disabled, "cancel-pause-termination-process-button", defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon), new ButtonProps(getTranslation("Common.Save"), defaultProps.Content, (_arg_2) => {
        saveState[1](new SaveStatus(1));
        const dto = pauseState[0];
        startImmediate(singleton.Delay(() => singleton.Bind(props.PauseTerminationProcessFn(dto), (_arg) => {
            const result = _arg;
            const arg = (result.tag === 1) ? (new SaveStatus(3, result.fields[0])) : (new SaveStatus(2));
            saveState[1](arg);
            return singleton.Zero();
        })));
    }, defaultProps.Disabled, "save-pause-termination-process-button", defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon), getTranslation("Common.Close"), (_arg_3) => {
        props.CloseModalFn();
    }, singleton_1([getTranslation("Common.Saved"), saveState[0]]));
}, void 0, uncurry(2, void 0), void 0, "renderPauseTerminationProcessModal", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\PauseTerminationProcess\\View.fs", 84);

